export default "__VITE_ASSET__BYV4hrV4__"